import React, { useEffect } from 'react';
import $ from 'jquery';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button, TextField } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { Header } from '../../components/Header';
import Toast from '../../components/Toast';
import { useAuth } from '../../hooks/Auth';
import { parseCpfCnpj } from '../../helpers/parseValues';
import { options } from '../../helpers/toastOptions';
import {
  SignInTitle,
  Container,
  Route,
  Content,
  Paper,
  Form,
  FormButtonWrapper
} from './styled';

const SignIn = () => {
  const history = useHistory();

  const signInValidationSchema = Yup.object().shape(
    {
      cnpj: Yup.string().when(['code', 'email'], {
        is: (code, email) => !code && !email,
        then: Yup.string().required('CNPJ / CPF obrigatório')
      }),
      code: Yup.string().when(['cnpj', 'email'], {
        is: (cnpj, email) => !cnpj && !email,
        then: Yup.string().required('Código obrigatório')
      }),
      email: Yup.string().when(['cnpj', 'code'], {
        is: (cnpj, code) => !cnpj && !code,
        then: Yup.string()
          .required('E-mail obrigatório')
          .matches(/^([\w.-]+)@([\w-]+)((\.(\w){2,25})+)$/, 'E-mail inválido')
      }),
      password: Yup.string().required('Senha obrigatória')
    },
    [
      ['code', 'email'],
      ['cnpj', 'email'],
      ['cnpj', 'code']
    ]
  );

  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: yupResolver(signInValidationSchema),
    mode: 'onChange',
    reValidateMode: 'onChange'
  });

  const { signInSite, signIn } = useAuth();

  const onSubmit = async (data) => {
    try {
      const { cnpj, email, password } = data;

      const parsedCpfCnpj = parseCpfCnpj(cnpj);

      const token = await signInSite({ cnpj: parsedCpfCnpj, email, password });

      history.push(`/area-do-cliente/minha-conta?token=${token}`);
    } catch (error) {
      toast(
        <Toast
          title="Credenciais inválidas."
          content="Tente novamente."
          type="error"
        />,
        options
      );
    }
  };

  useEffect(() => {
    const cpfCnpjOptions = {
      onKeyPress(cpf, _ev, _el, op) {
        const masks = ['000.000.000-000', '00.000.000/0000-00'];
        $('#cnpj').mask(cpf.length > 14 ? masks[1] : masks[0], op);
      }
    };

    $('#cnpj').length > 11
      ? $('#cnpj').mask('00.000.000/0000-00', cpfCnpjOptions)
      : $('#cnpj').mask('000.000.000-00#', cpfCnpjOptions);
  }, []);

  return (
    <Container>
      {/* <Header /> */}
      {/* <Route>
        <p>
          Home {'>'} Acesso Rápido {'>'} Pedido de Coleta
        </p>
      </Route> */}
      <Content>
        <SignInTitle>PEDIDO DE COLETA AVULSA</SignInTitle>

        <div>
          <p>Por favor informe uma das opções a seguir:</p>
          <p>CNPJ + Senha ou</p>
          <p>Código + Senha ou</p>
          <p>E-mail + Senha</p>
        </div>

        <Paper elevation={3}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Controller
              name="cnpj"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  label="CNPJ / CPF"
                  id="cnpj"
                  data-testid="documentInput"
                  fullWidth
                  {...field}
                  onChange={(e) => field.onChange(e.target.value)}
                  onBlur={(e) => field.onBlur(field.onChange(e.target.value))}
                  error={!!errors.cnpj && !!errors.code && !!errors.email}
                  helperText={
                    !!errors.cnpj &&
                    !!errors.code &&
                    !!errors.email &&
                    errors.cnpj?.message
                  }
                />
              )}
            />

            <Controller
              name="code"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  label="Código"
                  fullWidth
                  data-testid="codeInput"
                  {...field}
                  error={!!errors.cnpj && !!errors.code && !!errors.email}
                  helperText={
                    !!errors.cnpj &&
                    !!errors.code &&
                    !!errors.email &&
                    errors.code?.message
                  }
                />
              )}
            />

            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  label="E-mail"
                  fullWidth
                  data-testid="emailInput"
                  {...field}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                  }}
                  onBlur={(e) => {
                    field.onBlur(field.onChange(e.target.value.toLowerCase()));
                  }}
                  error={!!errors.cnpj && !!errors.code && !!errors.email}
                  helperText={
                    !!errors.cnpj &&
                    !!errors.code &&
                    !!errors.email &&
                    errors.email?.message
                  }
                />
              )}
            />

            <Controller
              name="password"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  label="Senha"
                  type="password"
                  data-testid="passwordInput"
                  fullWidth
                  {...field}
                  error={!!errors.password}
                  helperText={errors.password?.message}
                />
              )}
            />

            <Button
              type="button"
              style={{
                alignSelf: 'flex-start',
                textTransform: 'inherit',
                margin: -8
              }}
            >
              Esqueceu sua senha?
            </Button>

            <FormButtonWrapper>
              <Button type="button" variant="outlined" color="secondary">
                Criar conta
              </Button>

              <Button
                type="submit"
                variant="contained"
                data-testid="loginButton"
                disabled={!!isSubmitting}
              >
                Acessar
              </Button>
            </FormButtonWrapper>
          </Form>
        </Paper>
      </Content>
    </Container>
  );
};

export default SignIn;
